<template>
	<div id="app">
		<router-view/>
	</div>
</template>


<script>
import { mapState } from 'vuex'
import Events from '@/events'

import { url, colors, shares } from '@/data/pages'

let title = 'На пике формы'

export default {
	name: 'App',
	data() {
		return {
			rafId: null,
		}
	},
	head: {
		title: {
			inner: title,
			separator: ' ',
			complement: '',
		},
		meta: function() {
			return [
				{ property: 'og:title', content: title },
				{ property: 'og:description', content: this.description },
				{ property: 'og:image', content: `${url}/share-${this.route}.jpg` },
				{ property: 'og:site_name', content: 'KIA' },

				{ name: 'twitter:card', content: 'summary_large_image' },
				{ name: 'twitter:title', content: title },
				{ name: 'twitter:description', content: this.description },
				{ name: 'twitter:image', content: `${url}/share-${this.route}.jpg` },

				{ name: 'theme-color', content: this.color },
			]
		},
		link: function() {
			return [
				{ rel: 'shortcut icon', href: `${url}/favicon.png`, type: 'image/png' },
				{ rel: 'icon', href: `${url}/favicon.png`, type: 'image/png' },
			]
		},
	},
	created() {
		this.rafId = this.checkDevice()
	},
	methods: {
		checkDevice() {
			let d = window.innerWidth >= 960 ? 'desktop' : 'mobile'

			if (d !== this.device) this.$store.commit('setDevice', d)

			return requestAnimationFrame(this.checkDevice)
		},
	},
	computed: {
		...mapState({
			device: state => state.device,
		}),

		route() {
			return this.$route.name
		},

		color() {
			return colors[this.route]
		},

		description() {
			return shares[this.route]
		},
	},
	beforeDestroy() {
		cancelAnimationFrame(this.rafId)
	},
}
</script>


<style lang="less">
@import './styles/normalize';
@import './styles/variables';
@import './styles/animations';
@import './styles/grid';

body {
	max-width: 100vw;
	overflow-x: hidden;
	color: #fff;
	font-family: @font-regular;
	font-weight: 400;
}

#app {
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	opacity: 0;
	animation: fadeIn 0.4s forwards;
}
</style>
